<template>
    <v-card flat color="grey-f1" rounded="lg" class="d-flex align-center justify-center py-16 px-24" v-if="!employer?.interview?.isOnline">
        <p class="page--text text-center primary--text">
            <span> 면접장소: {{ employer?.interview?.location }} </span>
        </p>
        <expo-employer-map v-bind="{ employer }">
            <template #activator="{ attrs, on }">
                <v-btn small height="28" color="kakao" class="ml-10 my-n6" v-bind="attrs" v-on="on">
                    <v-icon size="20" color="kakao-marker" class="ml-n2">mdi-map-marker</v-icon>
                    <span> 카카오맵 확인 </span>
                </v-btn>
            </template>
        </expo-employer-map>
    </v-card>
</template>

<script>
import { initExpoEmployer } from "@/assets/variables";

import ExpoEmployerMap from "@/components/client/expo/employer/expo-employer-map.vue";

export default {
    components: {
        ExpoEmployerMap,
    },
    props: {
        employer: { type: Object, default: initExpoEmployer },
    },
};
</script>

<style>
</style>